'use strict';

require('../../helpers/users/users.module');

angular.module('far.models.education.educationReport', ['far.helpers.users'])
    .service('educationReport', function ($log, $http, usersHelper) {
        this.new = function (eventReportData, userTypes) {
            eventReportData.eventReportEdit = 0;

            return new EducationReport(eventReportData, userTypes);
        };

        this.get = function (eventId, userTypes, callback) {
            var eventReport = new EducationReport({eventReportEdit: 1}, userTypes);

            $http.get(Routing.generate('api_event_get_event_report', {id: eventId}))
                .then(function (response) {
                    eventReport.update(response.data);

                    if (typeof callback == 'function') {
                        callback(eventReport);
                    }
                })
                .catch(function (response) {
                    $log.error(response);
                });

            return eventReport;
        };

        function EducationReport(eventData, userTypes) {
            if (!eventData.users) {
                eventData.users = [];
            }

            angular.merge(this, eventData);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (eventData) {
                        if (eventData.documents_files) {
                            delete this.documents_files;
                        }

                        angular.merge(this, eventData);

                        this.updateUsers();

                        this.ascents.forEach(function (ascent) {
                            ascent.users = [];

                            if (angular.isArray(ascent.ascent_users)) {
                                ascent.ascent_users.forEach(function (user) {
                                    if (user.ascent_user_type_id.system_name === 'chief') {
                                        ascent.user_chief = user.user;
                                    } else if (user.ascent_user_type_id.system_name === 'instructor') {
                                        ascent.instructor = user.user;
                                    } else {
                                        ascent.users.push(user.user);
                                    }
                                })
                            }
                        });

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.eventReportEdit ? 'put' : 'post',
                            url = this.eventReportEdit ?
                                Routing.generate('api_event_put_event_report', {id: this.event.id}) :
                                Routing.generate('api_event_post_event_report');

                        // Могу преобразовывать data как хочу.
                        var data = angular.extend({}, this);

                        if (data.documents_files && data.documents_files.length > 0) {
                            data.documents_files = data.documents_files.filter(function (documentFile) {
                                return angular.isDefined(documentFile.serverData);
                            }).map(function (documentFile) {
                                return documentFile.serverData.id;
                            });
                        }


                        data.ascents = data.ascents.map(function (ascent) {
                            var users = [];

                            if (ascent.user_chief) {
                                users.push({
                                    user: ascent.user_chief.id,
                                    ascent_user_type_id: data.ascent_user_types.chief.id
                                });
                            }

                            if (ascent.instructor) {
                                users.push({
                                    user: ascent.instructor.id,
                                    ascent_user_type_id: data.ascent_user_types.instructor.id
                                });
                            }

                            ascent.users.forEach(function (user) {
                                users.push({
                                    user: {
                                        email: user.email,
                                        fio: user.fio
                                    },
                                    ascent_user_type_id: data.ascent_user_types.participant.id
                                })
                            });

                            ascent.ascent_users = users;
                            ascent.ascent_mountain_route = ascent.ascent_mountain_route.id;
                            ascent.ascent_type = ascent.ascent_type ? ascent.ascent_type.id : null;

                            delete(ascent.users);
                            delete(ascent.user_chief);

                            return ascent;
                        });

                        var users_complite = [];

                        data.users_complite.forEach(function (user) {

                            /*if ('user' in user) {
                                users_complite.push({user : user.user, event_education_user_type: 4})
                            } else {
                                users_complite.push({
                                    user: {
                                        email: user.email,
                                        fio: user.fio
                                    },
                                    event_education_user_type: 4 // Участник
                                })
                            }*/

                            users_complite.push({
                                user: {
                                    email: user.email,
                                    fio: user.fio
                                },
                                event_education_user_type: 4 // Участник
                            })
                        });

                        data.users_complite = users_complite;

                        delete(data.ascent_user_types);
                        delete(data.eventUserTypes);

                        return $http[method](url, data);
                    }
                }
            });

            usersHelper.initUsers(this, userTypes, 'users', 'event_education_user_type');
        }
    });
